<template>
    <LayoutMain>
        <SubSection class="pt-80 employment" v-if="type === 'view'">
            <div class="title_area">
                <h1>입사지원 조회</h1>
            </div>
            <form class="form_wrap">
                <div class="input_group">
                    <p><span class="ess">*</span> 채용공고</p>
                    <select v-model="recruit.recruitIdx">
                        <option value="">선택</option>
                        <option v-for="subject in clsList" :key="subject.idx" :value="subject.idx">{{ subject.subject }}</option>
                    </select>
                </div>

                <div class="input_group">
                    <p><span class="ess">*</span> 이름</p>
                    <input type="text" v-model="recruit.name" />
                </div>

                <div class="input_group">
                    <p><span class="ess">*</span> 비밀번호</p>
                    <input type="password" v-model="recruit.password" />
                </div>

                <div class="input_group">
                    <p><span class="ess">*</span> 휴대폰번호</p>
                    <input type="text" v-model="recruit.hpNo" />
                </div>

                <div class="button_wrap">
                    <button type="button" @click="$router.push('/recruit/recruitment_notice')">취소</button>
                    <button type="button" @click="findResume">조회</button>
                </div>
            </form>
        </SubSection>

        <SubSection class="pt-80 employment" v-else>
            <div class="title_area">
                <h1>{{ recruit.name }}님의 입사지원 조회</h1>
            </div>
            <table class="info" v-if="applyResumeList.length > 0">
                <thead>
                    <tr>
                        <th>채용공고</th>
                        <th>지원 상태</th>
                        <th>관리</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in applyResumeList" :key="item.idx">
                        <td>{{ item.recruitSubject }}</td>
                        <td>{{ item.applyYn === 'Y' ? item.status : '지원 취소' }}</td>
                        <td>
                            <div class="button_wrap" v-if="item.applyYn === 'Y'">
                                <button type="button" @click="() => cancelResume(item.idx)">지원 취소</button>
                                <button
                                    type="button"
                                    v-if="item.status === '접수'"
                                    @click="goToApply(item)"
                                >
                                    지원 수정
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="no-data" v-else>
                <p>
                    지원 이력이 없습니다. <br />
                    <span>*지원 내역이 있다면 해당공고의 채용구분, 이름(한글), 비밀번호, 휴대폰 번호를 다시 확인해주세요.</span>
                </p>
                <button type="button" @click="type = 'view'">돌아가기</button>
            </div>
        </SubSection>
    </LayoutMain>
</template>

<script>
import SubSection from '@/components/SubSection.vue';
import LayoutMain from '@/layouts/LayoutMain.vue';
import { getRecruitList, resumeCancel, resumeList } from '@/api';

export default {
    components: {
        LayoutMain,
        SubSection,
    },
    data() {
        return {
            type: 'view',
            clsList: [],
            recruit: {
                recruitIdx: '',
                name: '',
                hpNo: '',
                password: '',
            },
            applyResumeList: [],
        };
    },
    async mounted() {
        const data = await getRecruitList({ page: 1, size: 30 });
        this.clsList = data.paging.list;
    },
    methods: {
        async findResume() {
            const { recruitIdx, name, hpNo, password } = this.recruit;
            if (recruitIdx === '') return alert('채용공고를 선택해주세요.');
            if (name === '') return alert('이름을 입력해주세요.');
            if (hpNo === '') return alert('휴대폰번호를 입력해주세요.');
            if (password === '') return alert('비밀번호를 입력해주세요.');
            const { data } = await resumeList({ recruitIdx, name, hpNo, password });
            this.applyResumeList = data.list;
            this.type = 'list';
        },
        goToApply(item) {
            if (typeof window !== 'undefined' && window.sessionStorage) {
                window.sessionStorage.setItem('resumeName', this.recruit.name);
            }
            this.$router.push({
                path: '/recruit/resume/apply',
                query: {
                    resumeIdx: item.idx,
                    recruitIdx: this.recruit.recruitIdx,
                },
            });
        },
        async cancelResume(idx) {
            await resumeCancel(idx);
            alert('지원이 취소되었습니다.');
            // 리스트 최신화
            const { recruitIdx, name, hpNo, password } = this.recruit;
            const { data } = await resumeList({ recruitIdx, name, hpNo, password });
            this.applyResumeList = data.list;
        },
    },
};
</script>

<style scoped lang="scss">
.no-data {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fefefe;
    border: 1px solid #ddd;
    min-height: 300px;
    flex-direction: column;
    gap: 30px;

    p {
        text-align: center;
        color: #777 !important;
        font-size: 16px;
        line-height: 1.4;

        span {
            color: var(--red);
            font-size: 13px;
        }
    }

    button {
        background: #000;
        color: #fff;
        width: 80px;
        padding: 10px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid transparent;
        cursor: pointer;

        &:hover {
            color: #000;
            background: #fff;
            border: 1px solid #000;
        }
    }
}
</style>
